<header class="header"
        [ngStyle]="{
        justifyContent: isEmptyOrders ? 'flex-end' : 'space-between'
        }"
>
  <ng-container *ngIf="showHeader">
    <span class="header__quantity">
      {{ ordersQuantity  }} Order(s) Pending
    </span>
      <span class="header__quantity">
      Your place in line is {{ queueInfo.placeInLine }}
    </span>
      <span class="header__quantity">
      Waiting time is {{ queueInfo.estimatedTimeToBeginPreparation}}
    </span>
  </ng-container>
  <button
    class="header__close-btn"
    (click)="goPrevPage()"
    title="Close the cart"
  >
    <svg class="header__icon">
      <use
        xlink:href="./assets/images/icons-sprite.svg#icon-close"
      ></use>
    </svg>
  </button>
</header>

<app-orders-info-modal
  *ngIf="isShowModal"
  (close)="closeModal($event)"
  [currentOrder]="currentOrder"
  [locationId]="locationId"
  [updateOrderStatus]="updateOrderStatus"
>
</app-orders-info-modal>

<main *ngIf="!isLoadingStatuses; else spinner">
  <div class="container"
       *ngIf="!isEmptyOrders; else NoOrdersBlock"
  >

    <div class="order-card__container">
      <app-order-status *ngFor="let orderStatus of ordersStatus" [orderStatus]="orderStatus"></app-order-status>
    </div>
  </div>

  <div class="spinner-wrapper"
       *ngIf="isLoadingStatusesUpdate"
  >
    <app-spinner></app-spinner>
  </div>
</main>

<ng-template #NoOrdersBlock>
  <div class="container">
    <p class="no-orders">
      No active orders! 😢
    </p>
  </div>
</ng-template>

<ng-template #spinner>
  <div class="spinner-wrapper">
    <app-spinner></app-spinner>
  </div>
</ng-template>
